import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { guslStorage } from 'src/providers/session/GuslStorage';
import Config from 'src/config.json';

interface DownloadPayload {
  fileName: string;
}

const endpoint: string = `${Config.REACT_APP_PROTOCOL}://${Config.REACT_APP_BACKEND_URI}:${Config.REACT_APP_BACKEND_PORT}/edge/rest`;

export const conversationApi = createApi({
  reducerPath: 'conversationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: endpoint + '/aio',
    prepareHeaders: (headers) => {
      const token = guslStorage.getJwtSession()?.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    Downloadfile: builder.mutation<void, DownloadPayload>({
      query: ({ fileName }) => ({
        url: `/file/download?filename=${fileName}`,
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      }),
    }),
  }),
});

export const { useDownloadfileMutation } = conversationApi;
